export type Density = 1 | 2 | 3;
export const DENSITIES: Array<Density> = [1, 2, 3];
